import React, { useState, useEffect, useRef } from 'react';
import schoolData from '../data/dataset.json';

const SearchBar = ({ onSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [placeholder, setPlaceholder] = useState('Enter your school district');
  const searchRef = useRef(null);

  useEffect(() => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    
    const animatePlaceholder = async () => {
      while (true) {
        await sleep(1000); // Changed from 5000 to 1000
        
        // Delete everything after "Enter your "
        let text = 'Enter your school district';
        for (let i = text.length; i >= 10; i--) {
          setPlaceholder(text.slice(0, i));
          await sleep(50);
        }
        
        await sleep(1000); // Unchanged delay when at "Enter your "
        
        // Type "charter school" after "Enter your "
        text = 'Enter your ';
        const toType = 'charter school';
        for (let i = 0; i < toType.length; i++) {
          text += toType[i];
          setPlaceholder(text);
          await sleep(50);
        }
        
        await sleep(1000); // Changed from 5000 to 1000
        
        // Delete everything after "Enter your "
        for (let i = text.length; i >= 10; i--) {
          setPlaceholder(text.slice(0, i));
          await sleep(50);
        }
        
        await sleep(1000); // Add delay when at "Enter your "
        
        // Type "school district" after "Enter your "
        text = 'Enter your ';
        const toTypeBack = 'school district';
        for (let i = 0; i < toTypeBack.length; i++) {
          text += toTypeBack[i];
          setPlaceholder(text);
          await sleep(50);
        }
      }
    };

    animatePlaceholder();
  }, []);

  const handleSearch = (value) => {
    setSearchTerm(value);
    if (value.length >= 3) {
      const filtered = schoolData
        .filter(school => 
          school.district.toLowerCase().includes(value.toLowerCase()))
        .sort((a, b) => b.students - a.students)
        .slice(0, 4);
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (school) => {
    onSelect(school);
    setSearchTerm('');
    setSuggestions([]);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && searchTerm.length > 1 && suggestions.length > 0) {
      handleSelect(suggestions[0]);
    }
  };

  return (
    <div className="search-container" ref={searchRef}>
      <div className="input-wrapper">
        <input
          type="text"
          className="search-input"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
      {suggestions.length > 0 && (
        <div className="autofill-container">
          {suggestions.map((school, index) => (
            <div
              key={index}
              className="autofill-option"
              onClick={() => handleSelect(school)}
            >
              {school.district}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchBar; 